<template>
  <div class="crud_module--Select_weekday">
<!--    {{data}}-->
    <div class="text" v-if="action == 'View'">
        {{display_name()}}
    </div>
    <div class="text" v-else-if="action == 'List'">
        {{display_name()}}
    </div>
    <div v-else>
        <SelectionFrom
            :disabled="is_disabled"
            :value="value"
            :closeable="closeable"
            :filterable="filterable"
            :multiple="multiple"
            @input="selected"
            :option="selectKey"
            :setup="setup"
            :optionKey="optionKey"
            :limit="limit"
            :key="updateCount"
        />
    </div>
    
  </div>
</template>

<script>
import SelectionFrom from '@/components/modules/SelectionFrom'

export default {
  components: {
    SelectionFrom,
  },
  props: ["data","k","field","action","options"],
  beforeMount() {
    this.col = this.field.key;
    if(this.field?.multiple != undefined){
      this.multiple = this.field?.multiple;
      if (this.multiple === false){
        this.closeable = false;
      }
    }
    if(this.field?.closeable != undefined){
      this.closeable = this.field?.closeable;
    }
    if(this.field?.filterable != undefined){
      this.filterable = this.field?.filterable;
    }
    if(this.field?.setup != undefined){
      this.setup = this.field?.setup;
    }
    if (this.field?.optionKey){
      this.optionKey = this.field.optionKey;
    }
    if (this.field?.limit){
      this.limit = this.field?.limit;
    }

    if(this.data != undefined && this.data[this.col] != undefined){
        var arr = this.data[this.col].toString().split(',');
        this.value = this.selectKey.filter(row=>arr.includes(row[this.setup.value].toString()));
    }
  },
  methods: {
    selected(obj){
      var arr = [];
      console.log(obj)
      for(var i in obj){
        arr.push(obj[i][this.setup.value])
      }
      if(this.field?.output == "Object"){
        let ret={};
        ret[this.col]=obj;
        this.$emit("input", ret);
      }
      else {
        this.$emit("input", arr.join(','));
      }
    },
    display_name(){
      var arr1 = [];
      try {
        var arr = this.data[this.col].toString().split(',');
        var da = this.selectKey.filter(row=>arr.includes(row[this.setup.value].toString()));
        //   var da = arr;

        for(var i in da){
            arr1.push(da[i][this.setup.label]);
        }

        // console.log(this.col);
        // console.log('asdfasdf');
        // console.log(da.length);
        //   console.log(da);
        //   console.log(arr1.length);
        //   console.log(arr1);

        if (da.length<=0 && this.col != undefined && this.col==="locIds"){
            arr1.push("沒有限制");
        }
        
      } catch (error) {
        
      }
      return arr1.join(',')
    }
  },
  computed:{
    is_disabled(){
      if(this.field.disabledFun != undefined && typeof this.field.disabledFun == "function"){
        if(this.field.disabledFun(this.data)){
          this.value = [];
          // this.$emit("input", "");
          this.updateCount++;
          return true;
        }
      }
      // if(data.cp_loc_flag == 1){
        
      // }
      return false;
    },
    selectKey(){
      var _this = this;

        if (!this.field?.option){

        return this.options[this.optionKey];
      }else{
        return this.field.option.map(r=>{
          r.name = _this.$t(r.name);
          return r;
        });
      }

    }
  },
  data() {
    return {
      multiple:true,
      filterable:false,
      closeable:true,
      value:undefined,
      col:"",
      setup:{label:'name',value:'id'},
      optionKey:"",
      limit:0,
      updateCount:0
    }
  }
}
</script>

<style lang="scss">
.crud_module--Select_weekday{
  width: 100%;
}
</style>